var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"required-field-wrapper pe-2"},[_c('img',{staticClass:"me-1",attrs:{"src":require("@/assets/images/ic_warning.svg"),"width":"18"}}),_c('span',{staticClass:"required-error mt-1"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }